import { Controller } from "@hotwired/stimulus";

let Glide;

export default class extends Controller {
  connect() {
    import("@glidejs/glide").then((module) => {
      Glide = module.default;
      this.init();
    });
  }

  init() {
    this.slider = new Glide(this.element.querySelector(".glide"), {
      type: "carousel",
      perView: 3,
      rewind: false,
      bound: true,
      gap: 64,
      breakpoints: {
        1350: {
          perView: 2,
        },
        768: {
          perView: 1,
        },
      },
    });

    this.slider.mount();
  }

  next() {
    this.slider.go(">");
  }

  prev() {
    this.slider.go("<");
  }

  disconnect() {
    this.slider.destroy();
  }
}
